<template>
    <div class="notice-manager">
        <a-form>
            <a-form-item
                    label="公告內容"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }">
                <a-textarea placeholder="請輸入公告內容" v-model.trim="content" :rows="4"/>
                <a-button @click="sub">提交</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                content:''
            }
        },
        methods: {
            sub(){
                let self=this;
                if(this.content===''){
                    this.$Message.warning('请输入公告内容')
                    return false;
                }
                this.$http({
                    method: 'post',
                    url: '/manager/notice/update',
                    data:{
                        notice:self.content
                    }
                }).then(function(res){
                    self.loading=false;
                    self.$Message.success('操作成功')
                }).catch(err=>{
                })
            },
            getDetail(){
                let self=this;
                this.$http({
                    method: 'get',
                    url: '/manager/notice/detail',
                }).then(function(res){
                    self.content=res.data.notice
                }).catch(err=>{
                })
            }
        },
        created() {
            this.getDetail();
        },
    }
</script>
<style lang="less">
    div.notice-manager{

    }
</style>